import { Link } from 'react-router-dom';
import { useState, useEffect } from 'react';

export default function Navigation() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navLinks = [
    { name: 'Home', path: '/' },
    { name: 'About', path: '/about' },
    { name: 'Services', path: '/services' },
    { name: 'Gallery', path: '/gallery' },
    { name: 'Blog', path: '/blog' },
    { name: 'Areas', path: '/areas' },
    { name: 'Testimonials', path: '/testimonials' },
    { name: 'Socials', path: '/socials' },
    { name: 'Contact', path: '/contact' },
  ];

  return (
    <>
      <header className={`sticky top-0 z-50 transition-all duration-300`} style={{ background: '#ffffff' }}>
        <div className={`w-full px-6 transition-all duration-300 ${isScrolled ? 'py-2' : 'py-4'}`}>
          <div className="max-w-7xl mx-auto">
            <div className={`flex items-center justify-between bg-[#FAF7F2] rounded-full px-6 shadow-lg transition-all duration-300 ${isScrolled ? 'py-2' : 'py-3'}`}>
              <Link to="/" className="flex items-center">
                <img
                  src="https://images.builderservices.io/s/cdn/v1.0/i/m?url=https%3A%2F%2Fstorage.googleapis.com%2Fproduction-ipage-v1-0-6%2F926%2F1261926%2FlwKYG8wo%2F37cf9555ec8743aabbbe79e5c48f3558&methods=resize%2C500%2C5000"
                  alt="Brushour Logo"
                  className={`transition-all duration-300 ${isScrolled ? 'h-8' : 'h-10'}`}
                />
              </Link>

              <nav className="hidden md:flex items-center gap-6">
                {navLinks.map((link) => (
                  <Link
                    key={link.path}
                    to={link.path}
                    className="text-sm font-medium transition-colors duration-300 hover:text-amber-700 whitespace-nowrap text-stone-600 cursor-pointer"
                  >
                    {link.name}
                  </Link>
                ))}
                <Link
                  to="/booking"
                  className="px-5 py-2 bg-amber-600 hover:bg-amber-700 text-white text-sm font-medium rounded-full transition-colors duration-300 whitespace-nowrap cursor-pointer"
                >
                  Book Visit
                </Link>
              </nav>

              <a
                href="tel:+447595037441"
                className="hidden md:flex items-center gap-2 px-5 py-2 bg-stone-800 hover:bg-stone-900 text-white text-sm font-medium rounded-full transition-colors duration-300 whitespace-nowrap cursor-pointer"
              >
                <i className="fas fa-phone"></i>
                Call Us
              </a>

              {/* Mobile Menu Buttons */}
              <div className="flex md:hidden items-center gap-2">
                <a
                  href="tel:+447595037441"
                  className="flex items-center justify-center gap-2 px-4 py-2 bg-amber-600 hover:bg-amber-700 text-white text-xs font-medium rounded-full transition-colors duration-300 cursor-pointer whitespace-nowrap"
                >
                  <i className="fas fa-phone text-xs"></i>
                  Call
                </a>
                <button
                  onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
                  className="flex items-center justify-center gap-2 px-4 py-2 bg-stone-800 hover:bg-stone-900 text-white text-xs font-medium rounded-full transition-colors duration-300 cursor-pointer whitespace-nowrap"
                  aria-label="Toggle menu"
                >
                  <i className={`fas ${mobileMenuOpen ? 'fa-times' : 'fa-bars'} text-xs`}></i>
                  Menu
                </button>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <div className="fixed inset-0 z-40 md:hidden">
          <div 
            className="absolute inset-0 bg-black/50"
            onClick={() => setMobileMenuOpen(false)}
          ></div>
          <nav className="absolute top-24 right-4 left-4 bg-white shadow-lg rounded-2xl overflow-hidden">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                onClick={() => setMobileMenuOpen(false)}
                className="block px-6 py-4 text-stone-600 hover:bg-stone-50 hover:text-amber-700 transition-colors duration-300 border-b border-stone-100 last:border-b-0 cursor-pointer"
              >
                {link.name}
              </Link>
            ))}
            <Link
              to="/booking"
              onClick={() => setMobileMenuOpen(false)}
              className="block px-6 py-4 text-amber-700 font-semibold hover:bg-stone-50 transition-colors duration-300 cursor-pointer"
            >
              Book Visit
            </Link>
          </nav>
        </div>
      )}
    </>
  );
}
